import { styled } from "@mui/material/styles";

const StyledOrderCards = styled("div")(
  ({ theme }) => `
  

    .order-card {
    text-align: center;
    border-radius: 0;
    box-shadow: none;
    max-height: 80px; 
  }

  @media (min-width: 600px) { 
    .order-card {
      max-height: 96px;
    }
  }


  .order-card-content {
    padding: 20px;
    @media (max-width: 1200px){
    padding: 12px;
    margin-top: 2px;
    }
    @media (max-width: 850px){
    padding: 12px;
    padding-left: 16px;
    }
    @media (max-width: 600px){
    padding: 12px;
    }
  }

  .order-card-title {
    text-align: left;
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${theme.palette.customColor.secondarySecond};
    margin-bottom: 8px;
  }

  .order-card-value {
    text-align: left;
    font-family: 'Lexend', sans-serif;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: ${theme.palette.primary.main};
    position: relative;
    min-height: 24px;
  }
`
);

export default StyledOrderCards;
